import { Injectable, signal } from '@angular/core'

import { FlxModalRef } from '@flowx/angular-ui-toolkit'

@Injectable({
  providedIn: 'root',
})
export class ScriptingModalStore {
  activeModal = signal<FlxModalRef | null>(null)
}
